// extracted by mini-css-extract-plugin
module.exports =  {"container":"_1c9529d521--container--aBkZJ","wrapper":"_1c9529d521--wrapper--pvyL5","title":"_1c9529d521--title--oRGTJ"};